export default __webpack_public_path__ + "static/media/7.50de7138.webp";